import React, { useState, useEffect } from "react";
import { Chatbox, Inbox } from "@talkjs/react";
import { Row, Col, Button } from "reactstrap";
import { Capacitor } from "@capacitor/core";
import { Breadcrumbs, TokenAppenditure } from "../Utility/common";
import { MdClose, MdOutlineClose } from "react-icons/md";

const Chat = ({
  disableBreadCrumbs = false,
  campaignId,
  postId,
  setTabValue,
  isPopup = false,
  onClose,
}) => {
  const [isMobile, setIsMobile] = useState(false);
  const isNative = Capacitor.isNativePlatform();
  console.log("TalkJS filter values", { campaignId, postId });

  useEffect(() => {
    const checkMobile = () => {
      setIsMobile(window.innerWidth <= 768 || Capacitor.isNativePlatform());
    };
    checkMobile();
    window.addEventListener("resize", checkMobile);
    return () => window.removeEventListener("resize", checkMobile);
  }, []);

  const LoadingComponent = () => (
    <div className="d-flex align-items-center justify-content-center h-100">
      Loading chats...
    </div>
  );

  const handleClose = () => {
    if (isMobile) {
      if (isPopup) {
        setTabValue(0);
      } else if (onClose) {
        onClose();
      }
    }
  };

  const renderChat = () => {
    if (isMobile) {
      return (
        <div className="mobile-chat-overlay">
          <div className="mobile-chat-header pt-5">
            <Button
              className="close-button mt-2"
              onClick={handleClose}
              aria-label="Close chat"
            >
              <MdClose />
            </Button>
          </div>
          <div className="mobile-chat-content pt-3">
            <div className="mobile-chatbox-wrapper">
              <Chatbox
                feedFilter={{
                  custom: {
                    campaignId: ["==", String(campaignId)],
                    postId: ["==", String(postId)],
                  },
                }}
                loadingComponent={<LoadingComponent />}
                style={{ height: "100%" }}
              />
            </div>
          </div>
        </div>
      );
    }

    return (
      <div
        className="messages-container bg-transparent rounded"
        style={{ height: "calc(80vh - 10rem)" }}
      >
        <div className="h-100 bg-white">
          <Chatbox
            feedFilter={{
              custom: {
                campaignId: ["==", String(campaignId)],
                postId: ["==", String(postId)],
              },
            }}
            loadingComponent={<LoadingComponent />}
            style={{ height: "100%" }}
          />
        </div>
      </div>
    );
  };

  return (
    <React.Fragment>
      <div className="page-content">
        <div className="container">
          <Row>
            <Col className="col-12">
              {!disableBreadCrumbs && (
                <>
                  {!isNative &&
                    Breadcrumbs(
                      "Chat",
                      "Home",
                      `/dashboard${TokenAppenditure()}`
                    )}
                  <h4 className="madeGentle mb-3">Chat</h4>
                </>
              )}
              {renderChat()}
            </Col>
          </Row>
        </div>
      </div>

      <style>
        {`
        .messages-container {
          background-color: #f8f9fa !important;
          overflow: hidden;
        }
        .bg-light {
          background-color: #f8f9fa !important;
        }
        .mobile-chat-overlay {
          position: fixed;
          top: 0;
          left: 0;
          right: 0;
          bottom: 0;
          background: white;
          z-index: 1050;
          display: flex;
          flex-direction: column;
          height: 100vh;
        }
        .mobile-chat-header {
          height: 48px;
          display: flex;
          align-items: center;
          justify-content: flex-end;
          padding: 0 1rem;
          background: white;
          flex-shrink: 0;
        }
        .close-button {
          background: none;

          justify-content:center;
          align-items:center;
          font-size: 22px;
          padding: 0.15rem;
          cursor: pointer;
          z-index:9999;
          max-height:40px;
          color: #666;
          line-height:0;
        }
        .mobile-chat-content {
          flex: 1;
          display: flex;
          flex-direction: column;
          overflow: hidden;
          height: calc(100vh - 48px);
        }
        .mobile-chatbox-wrapper {
          flex: 1;
          height: 100%;
          display: flex;
          flex-direction: column;
        }
        .mobile-chatbox-wrapper > div {
          flex: 1;
          height: 100%;
        }
        `}
      </style>
    </React.Fragment>
  );
};

export default Chat;
